import _ from "lodash";
import useSWRImmutable from "swr/immutable";

export type FeatureFlags = {
    hide_interpretation_recalculate_button: boolean;
    allow_disabling_2fa?: boolean;
    automatic_interpretation: boolean;
    foot_pound: boolean;
    other_interpretations_as_object: boolean;
};

function useFeatureFlags() {
    const swrRes = useSWRImmutable<FeatureFlags>("/feature-flags");
    return {
        featureFlags: swrRes.data,
        ..._.omit(swrRes, "data"),
    };
}

export default useFeatureFlags;
